module.exports = __webpack_public_path__ + "static/img/1.d283a10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1.png
// module id = A1tS
// module chunks = 5